import { authManager } from '@/@core/services/auth/auth';
import { useUserStore } from '@/stores/userStore';

export const beforeRequestInterceptor = async (request) => {
  const userStore = useUserStore();
  const token = userStore.user?.access_token;
  if (token) {
    request.headers.set('Authorization', `Bearer ${token}`);
    request.headers.set('CatchAuthorizationType', 'aa_oidc');
  } else {
    console.log('No token found, redirecting to login...');
    // Redirect user to login flow
    authManager.signinRedirect();
    throw new Error('No token available. Redirecting to login.');
  }
  return request;
};
